module.exports = __webpack_public_path__ + "img/w3_bookmark_square_dark.8c070827.png";